import { EnvironmentModel, EnvName } from '@fb/models';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: EnvironmentModel = {
  shortName: 'tw',
  production: false,
  useMocks: false,
  envName: EnvName.DEV,
  apiHost: (window as any).apiHost || 'https://api-dev.twu.team/api/v1/',
  wssHost: (window as any).wssHost || 'wss://api-dev.twu.team/api/v1/',
  lmsHost: (window as any).lmsHost || 'https://lms-dev.twu.team/',
  assetsUrl: 'https://dev-fb.twu.team',
  financeConfluenceLink: 'https://wiki.time2go.tech/display/CIS/Main+Page',
  slackTeamId: 'T01FZLAFN9Z',
  blockAiChat: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
